import { SetStateAction } from "react";
import { getInputFormat } from "../getInputFormat";
import { updateWindowValue } from "../updateWindowValue";
import { stdObject } from "../../../../data/types/stdObject";
import {
  extraListCodes,
  purchasesCodes,
  rolPricesforCheckBox,
  salesCodes,
} from "../../../../data/main";
import { colors } from "../../../../data/colors";
import {
  cashCodesOptions,
  filesCodesOptions,
  newCodesOptions,
  printCodesOptions,
  rolPricesLabels,
} from "../../../MainStructure/SearchBar/data/searchItemUtils";
import { splitString } from "../../../../utils/splitString";
import { docCodes } from "../../../../data/docCodes";
import { sectionsList } from "../../../../data/sectionsList";

export const writeRolsInputInfo = (params: stdObject) => {
  const {
    t,
    modalData,
    windowValues,
    pricesRates,
    packInputFormat,
    packUpdateWindow,
  } = params;
  let tempRolsInput: Array<stdObject> = [];

  if (windowValues.tarifas?.length > 0) {
    windowValues.tarifas.forEach((v: stdObject, index: number) => {
      tempRolsInput.push({
        label: pricesRates.find((e: stdObject) => e.CODTAR === v.TARUS2).NOMTAR,
        value: v.VERUS2,
        tabId: 2,
        ...getInputFormat("checkbox", packInputFormat),
        style: { width: 300 },
        onChange: (o: { target: { value: SetStateAction<string> } }) =>
          updateWindowValue({
            key: "tarifas",
            code: index,
            field: "VERUS2",
            value: Number(o.target.value) ? 0 : 1,
            ...packUpdateWindow,
          }),
      });
    });
  }

  modalData.tabs?.forEach((e: Array<string>, index: number) => {
    e.forEach((v: string) => {
      const codeBase =
        v.length === 6 && v.endsWith("ROL") ? v.substring(0, v.length - 3) : v;
      if (extraListCodes.includes(v)) {
        tempRolsInput.push({
          label: t(`c.${codeBase}`),
          tabId: index,
          type: "label",
          style: { backgroundColor: colors.darkGrey },
        });
      }
      tempRolsInput.push({
        label: newCodesOptions.includes(v)
          ? t("p.new")
          : cashCodesOptions.includes(v)
            ? t("p.cash")
            : printCodesOptions.includes(v)
              ? t("p.print")
              : filesCodesOptions.includes(v)
                ? t("p.files")
                : extraListCodes.includes(v)
                  ? t("p.permissions")
                  : codeBase === "COM"
                    ? t("p.commissionGroup")
                    : codeBase === "TRA"
                      ? t("p.automaticTransfer")
                      : t(`c.${codeBase}`),
        code: v,
        value: "info" in windowValues ? windowValues.info[v] : "",
        tabId: index,
        ...getInputFormat(codeBase, packInputFormat),
        style: { width: 300 },
        onChange: (e: { target: { value: SetStateAction<string> } }) =>
          updateWindowValue({
            key: "info",
            code: v,
            value: rolPricesforCheckBox.includes(v)
              ? Number(e.target.value)
                ? 0
                : 1
              : e.target.value,
            ...packUpdateWindow,
          }),
      });
    });
  });

  if (windowValues.precios) {
    Object.keys(windowValues.precios).forEach((e: string) => {
      if (e !== "CODUS1") {
        const codeParts = splitString(e, 3);
        if (codeParts.length === 2) {
          tempRolsInput.push({
            label:
              codeParts[0] === "PRE"
                ? t(`c.PREP`)
                : codeParts[0] === "SAL"
                  ? t(`c.SALP`)
                  : t(`c.${codeParts[0]}`),
            tabId: 2,
            type: "label",
            style: {
              backgroundColor:
                codeParts[0] === "SEV"
                  ? colors.services
                  : purchasesCodes.includes(codeParts[0])
                    ? colors.purchases
                    : colors.sales,
            },
          });
        }

        const tRolPrices =
          rolPricesLabels[codeParts[1] as keyof typeof rolPricesLabels];

        if (salesCodes.includes(codeParts[0]) && codeParts[1] === "US1") {
          tRolPrices.input = "modify";
        }

        tempRolsInput.push({
          label: t(tRolPrices.label),
          value: windowValues.precios[e],
          tabId: 2,
          ...getInputFormat(tRolPrices.input, packInputFormat),
          style: { width: 300 },
          onChange: (o: { target: { value: SetStateAction<string> } }) =>
            updateWindowValue({
              key: "precios",
              code: e,
              value:
                tRolPrices.input === "checkbox"
                  ? Number(o.target.value)
                    ? 0
                    : 1
                  : o.target.value,
              ...packUpdateWindow,
            }),
        });
      }
    });
  }

  const writeLabel = (v: string, e: stdObject) => {
    switch (v) {
      case "G1":
        return t("c.B1");
      case "G2":
        return t("c.B2");
      case "G3":
        return t("c.CLI2");
      default:
        if (v === `USU${e.id}`) {
          return t(`p.${e.title}`);
        } else {
          switch (v.at(-1)) {
            case "N":
              return t("p.new");
            case "C":
              return t("p.cash");
            case "P":
              return t("p.print");
            case "V":
              return t("p.see");
            default:
              return t(`c.${v}`);
          }
        }
    }
  };

  sectionsList.forEach((e: stdObject) => {
    if (windowValues[e.id.toLowerCase()]) {
      Object.keys(windowValues[e.id.toLowerCase()]).forEach((v: string) => {
        const tempInput = ["V1", "D4", "F5", "F10", "Z6"].includes(v)
          ? "editOptions"
          : v === "D2"
            ? "infoCommOptions"
            : v === "C1R"
              ? "seePrintSaveOptions"
              : v === "Z2"
                ? "selectUsersOptions"
                : ["A", "B", "C"].includes(e.id) &&
                    v.startsWith(e.id) &&
                    Number(v.at(-1)) > 0
                  ? "editVoid"
                  : "checkbox";
        tempRolsInput.push({
          label: writeLabel(v, e),
          value:
            v === `USU${e.id}`
              ? windowValues.info[e.id]
              : windowValues[e.id.toLowerCase()][v],
          tabId: 1,
          ...getInputFormat(tempInput, packInputFormat),
          style: {
            width: 300,
            color: v === `USU${e.id}` ? colors.white : null,
            fontWeight: v === `USU${e.id}` ? "bolder" : null,
            backgroundColor:
              v === `USU${e.id}`
                ? colors[e.type]
                : tempInput === "checkbox" ||
                    ["V1", "D2", "D4", "F5", "F10"].includes(v)
                  ? null
                  : colors.lightGrey,
          },
          onChange: (o: { target: { value: SetStateAction<string> } }) =>
            updateWindowValue({
              key: v === `USU${e.id}` ? "info" : e.id.toLowerCase(),
              code: v === `USU${e.id}` ? e.id : v,
              value:
                tempInput === "checkbox"
                  ? Number(o.target.value)
                    ? 0
                    : 1
                  : o.target.value,
              ...packUpdateWindow,
            }),
        });

        if (v.at(-1) === "P") {
          const fileCode = docCodes[v.slice(0, 2)] + "DOCUS1";
          tempRolsInput.push({
            label: t("p.files"),
            value: windowValues.precios[fileCode],
            tabId: 1,
            ...getInputFormat("files", packInputFormat),
            style: { width: 300 },
            onChange: (o: { target: { value: SetStateAction<string> } }) =>
              updateWindowValue({
                key: "precios",
                code: fileCode,
                value: o.target.value,
                ...packUpdateWindow,
              }),
          });
        }
      });
    }
  });
  return tempRolsInput;
};
